import {Observable} from 'rxjs';
import {SecurityContextHolder} from "../security/context/security-context-holder";
import {IContext} from "../security/context/context";

export function initializeAppFactory(securityContextHolder: SecurityContextHolder): () => Promise<void>
{
  // https://javascript.plainenglish.io/simple-way-of-loading-data-before-page-load-in-angular-f98c079cff55
  return () => securityContextHolder.loadData();
}
